export default "__VITE_ASSET__HyzTviQe__"